export default __webpack_public_path__ + "static/media/blog-permeable-vs-concrete-001.cb7f0076.jpg";